import { STAGES, STAGE_COUNT } from "../stages";
import { getStageState } from "../lib/journey";

// Horizontal progress stepper. One dot per stage. Click to jump.
export default function Stepper({ journey, currentIdx, onJump }) {
  return (
    <div className="s-stepper">
      <div className="s-stepper-track">
        {STAGES.map((s, i) => {
          const status = getStageState(journey, s.id).status;
          const isCurrent = i === currentIdx;
          const cls = isCurrent
            ? "current"
            : status === "done"
              ? "done"
              : status === "awaiting"
                ? "awaiting"
                : "pending";
          return (
            <div key={s.id} className="s-step-cell">
              <button
                type="button"
                className={`s-step ${cls}`}
                onClick={() => onJump?.(i)}
                style={{ background: "transparent", border: "none" }}
                aria-current={isCurrent ? "step" : undefined}
                aria-label={`Stage ${i + 1}: ${s.title}`}
              >
                <div className="s-step-dot">{status === "done" ? "✓" : i + 1}</div>
                <div className="s-step-label">{s.short}</div>
              </button>
              {i < STAGE_COUNT - 1 && (
                <div className={`s-step-line${status === "done" ? " filled" : ""}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
